/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} This_Page_Doesnt_Exist_Or_HasInputs */

const en_this_page_doesnt_exist_or_has = /** @type {(inputs: This_Page_Doesnt_Exist_Or_HasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This page doesn't exist or has been moved.`)
};

const es_this_page_doesnt_exist_or_has = /** @type {(inputs: This_Page_Doesnt_Exist_Or_HasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta página no existe o ha sido movida.`)
};

const fr_this_page_doesnt_exist_or_has = /** @type {(inputs: This_Page_Doesnt_Exist_Or_HasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette page n'existe pas ou a été déplacée.`)
};

const de_this_page_doesnt_exist_or_has = /** @type {(inputs: This_Page_Doesnt_Exist_Or_HasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Seite existiert nicht oder wurde verschoben.`)
};

const ja_this_page_doesnt_exist_or_has = /** @type {(inputs: This_Page_Doesnt_Exist_Or_HasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`お探しのページは存在しないか、移動した可能性があります。`)
};

const zh_this_page_doesnt_exist_or_has = /** @type {(inputs: This_Page_Doesnt_Exist_Or_HasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此页面不存在或已被移动。`)
};

const ar_this_page_doesnt_exist_or_has = /** @type {(inputs: This_Page_Doesnt_Exist_Or_HasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هذه الصفحة غير موجودة أو تم نقلها.`)
};

const id_this_page_doesnt_exist_or_has = /** @type {(inputs: This_Page_Doesnt_Exist_Or_HasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halaman ini tidak ada atau telah dipindahkan.`)
};

const it_this_page_doesnt_exist_or_has = /** @type {(inputs: This_Page_Doesnt_Exist_Or_HasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questa pagina non esiste o è stata spostata.`)
};

const ru_this_page_doesnt_exist_or_has = /** @type {(inputs: This_Page_Doesnt_Exist_Or_HasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Эта страница не существует или была перемещена.`)
};

const pt_this_page_doesnt_exist_or_has = /** @type {(inputs: This_Page_Doesnt_Exist_Or_HasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta página não existe ou foi movida.`)
};

const ko_this_page_doesnt_exist_or_has = /** @type {(inputs: This_Page_Doesnt_Exist_Or_HasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`존재하지 않거나 이동된 페이지입니다.`)
};

/**
* | output |
* | --- |
* | "This page doesn't exist or has been moved." |
*
* @param {This_Page_Doesnt_Exist_Or_HasInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const this_page_doesnt_exist_or_has = /** @type {((inputs?: This_Page_Doesnt_Exist_Or_HasInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<This_Page_Doesnt_Exist_Or_HasInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_this_page_doesnt_exist_or_has(inputs)
	if (locale === "es") return es_this_page_doesnt_exist_or_has(inputs)
	if (locale === "fr") return fr_this_page_doesnt_exist_or_has(inputs)
	if (locale === "de") return de_this_page_doesnt_exist_or_has(inputs)
	if (locale === "ja") return ja_this_page_doesnt_exist_or_has(inputs)
	if (locale === "zh") return zh_this_page_doesnt_exist_or_has(inputs)
	if (locale === "ar") return ar_this_page_doesnt_exist_or_has(inputs)
	if (locale === "id") return id_this_page_doesnt_exist_or_has(inputs)
	if (locale === "it") return it_this_page_doesnt_exist_or_has(inputs)
	if (locale === "ru") return ru_this_page_doesnt_exist_or_has(inputs)
	if (locale === "pt") return pt_this_page_doesnt_exist_or_has(inputs)
	return ko_this_page_doesnt_exist_or_has(inputs)
});